import { supabase, isConfigured } from './supabase';
import type { BillingTransaction, ContactRevenue, RehubUser } from '../types';

export async function getContactRevenue(contactId: string): Promise<ContactRevenue | null> {
  if (!isConfigured) return null;

  const { data, error } = await supabase
    .from('sales_contact_revenue')
    .select('*')
    .eq('contact_id', contactId)
    .maybeSingle();

  if (error) {
    console.error('[billing] getContactRevenue failed:', error);
    return null;
  }

  return data as ContactRevenue | null;
}

export async function getTransactionsForUser(userId: string): Promise<BillingTransaction[]> {
  if (!isConfigured) return [];

  const { data, error } = await supabase
    .from('billing_transactions')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('[billing] getTransactionsForUser failed:', error);
    return [];
  }

  return data as BillingTransaction[];
}

export async function searchRehubUsers(query: string): Promise<RehubUser[]> {
  if (!isConfigured || !query || query.length < 3) return [];

  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, credits')
    .ilike('email', `%${query}%`)
    .limit(10);

  if (error) {
    console.error('[billing] searchRehubUsers failed:', error);
    return [];
  }

  return data as RehubUser[];
}

export async function getRehubUserByEmail(email: string): Promise<RehubUser | null> {
  if (!isConfigured || !email) return null;

  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, credits')
    .eq('email', email.toLowerCase())
    .maybeSingle();

  if (error) {
    console.error('[billing] getRehubUserByEmail failed:', error);
    return null;
  }

  return data as RehubUser | null;
}

export function formatCurrency(cents: number, currency: string = 'gbp'): string {
  const amount = cents / 100;
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency.toUpperCase(),
  });
  return formatter.format(amount);
}
